//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import * as orderListApi from '@/api/orderListApi';
import LogDetail from './logDetail.vue';
export default {
  components: {
    LogDetail: LogDetail
  },
  data: function data() {
    return {
      constants: this.$constants,
      visible: false,
      listData: {
        list: [],
        total: 0
      },
      listPram: {
        page: 1,
        limit: this.$constants.page.limit[0]
      },
      recordId: null,
      listLoading: false
    };
  },
  mounted: function mounted() {},
  methods: {
    initOpen: function initOpen(recordId) {
      this.recordId = recordId;
      this.listPram.page = 1;
      this.visible = true;
      this.getLists();
    },
    getLists: function getLists() {
      var _this = this;
      this.listLoading = true;
      orderListApi.getOrderPayDetail(this.recordId).then(function (data) {
        _this.listData['list'] = data;
        _this.listLoading = false;
      }).catch(function (err) {
        _this.listLoading = false;
      });
    },
    handleSizeChange: function handleSizeChange(val) {
      this.listPram.limit = val;
      this.getLists();
    },
    // 切换页码
    handleCurrentChange: function handleCurrentChange(val) {
      this.listPram.page = val;
      this.getLists();
    },
    openLog: function openLog() {
      var _this$$refs$LogDetail;
      var row = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      (_this$$refs$LogDetail = this.$refs['LogDetailRef']) === null || _this$$refs$LogDetail === void 0 ? void 0 : _this$$refs$LogDetail.openInit(row);
    }
  }
};